function displaySignalValue(group, value) {
  return group.valueLabels?.[value] ?? String(value ?? "").replace(/_/g, " ");
}

export default function SignalFilterPanel({ signals, selected, onChange }) {
  const toggleValue = (signalId, value) => {
    onChange((current) => {
      const currentValues = current[signalId] ?? [];
      const nextValues = currentValues.includes(value)
        ? currentValues.filter((item) => item !== value)
        : [...currentValues, value];

      return { ...current, [signalId]: nextValues };
    });
  };

  const selectAllValues = (signalId, values) => {
    onChange((current) => ({ ...current, [signalId]: [...new Set(values ?? [])] }));
  };

  const removeAllValues = (signalId) => {
    onChange((current) => ({ ...current, [signalId]: [] }));
  };

  const removeAllSignals = () => {
    onChange((current) => {
      const next = { ...current };
      signals.forEach((group) => {
        next[group.id] = [];
      });
      return next;
    });
  };

  const selectedGroups = signals.map((group) => ({
    ...group,
    selectedValues: selected[group.id] ?? [],
  }));
  const hasSelectedSignals = selectedGroups.some((group) => group.selectedValues.length > 0);

  return (
    <details className="signal-workflow-section signal-filter-section collapsible-signal-section" open>
      <summary className="signal-workflow-heading">
        <span>03</span>
        <strong>Strategy Signal & Filters</strong>
      </summary>
      <div className="selected-signal-summary">
        {selectedGroups.map((group) => (
          <div key={group.id + "-summary"}>
            <span>{group.label}</span>
            <div>
              {group.selectedValues.length
                ? group.selectedValues.map((value) => <strong key={group.id + "-" + value}>{displaySignalValue(group, value)}</strong>)
                : <em>Inactive</em>}
            </div>
          </div>
        ))}
      </div>
      <details className="signal-filter-editor" open>
        <summary>Edit Signal Values</summary>
        <div className="signal-filter-actions">
          <span>Selection controls</span>
          <button type="button" onClick={removeAllSignals} disabled={!hasSelectedSignals}>
            Remove All Signals
          </button>
        </div>
        <div className="signal-grid">
          {signals.map((group) => {
            const values = group.values ?? [];
            const selectedValues = selected[group.id] ?? [];
            const allSelected = values.length > 0 && values.every((value) => selectedValues.includes(value));


            return (
              <div className="signal-group" key={group.id}>
                <div className="signal-group-heading">
                  <strong>{group.label}</strong>
                  <div className="signal-group-actions">
                    <button
                      type="button"
                      onClick={() => allSelected
                        ? removeAllValues(group.id)
                        : selectAllValues(group.id, values)}
                      disabled={values.length === 0}
                    >
                      {allSelected ? "Remove All" : "Select All"}
                    </button>
                  </div>
                </div>
                <div className="signal-value-list">
                  {values.map((value) => (
                    <label className="signal-value-option" key={group.id + "-" + value}>
                      <input
                        type="checkbox"
                        checked={selectedValues.includes(value)}
                        onChange={() => toggleValue(group.id, value)}
                      />
                      {displaySignalValue(group, value)}
                    </label>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </details>
    </details>
  );
}
